import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-update-device-detail',
  templateUrl: './update-device-detail.component.html',
  styleUrls: ['./update-device-detail.component.css']
})
export class UpdateDeviceDetailComponent implements OnInit {

  userData:any = [];
  userName = null;
  @Input() industryId: string;
  @Input() type: string;
  getStationDetailLoader = false;
  route = '';
  deviceDetails = [];
  error = false;
  formErrorDeviceId = [];
  realDeviceDetails = {};

  updateDeviceLoader = false;

  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) { }

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem('userData'));
    if(this.userData){
      this.userName = this.userData['user_profile_id'];
    }

    this.getDeviceDetail();
  }


  getDeviceDetail(){
    this.getStationDetailLoader = true;
    this.route  = 'get-ind-device-details';
    const token    = localStorage.getItem('userToken');
    this.deviceDetails = [];
    this.realDeviceDetails = {};

    let data = {'industry_id':this.industryId};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }

      if(response.status == 200){
        this.getStationDetailLoader = false;

        if(response.data.length){
          this.deviceDetails = response.data;
          this.realDeviceDetails = JSON.stringify(response.data);

        }
      }

    });
  }

  delete(id){
    const apiRoute = "delete-device";
    Swal({
      title: 'Are You Sure?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        const param= {
          id: id
        }
        const token    = localStorage.getItem('userToken');
        this._service.postRequestCreator(param, apiRoute, token).subscribe((response: any) => {

          if(response.status == 200){
            Swal('Success', 'Device deleted successfully', 'success');
            // location.reload();
            this.getDeviceDetail();
          } else if(response.status == 204) {
            // Swal({
            //   title: 'Your Session has expired. Please Login!',
            //   type: 'warning',
            //   showCancelButton: false,
            //   confirmButtonText: 'Okay',
            // });
            localStorage.removeItem('userToken');
            localStorage.removeItem('userData');
            this.router.navigate(['login']);
            // location.reload();
          }else{
            Swal('Oops...', 'Something went wrong!', 'error');
          }

        });

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal(
          'Cancelled',
          'Delete Cancelled.',
          'error'
        );
      }
    });
  }

  validateDevice(deviceNumber){

    this.error = false;

    if(this.deviceDetails[deviceNumber]['name'].trim() && this.deviceDetails[deviceNumber]['name'].trim() != ' '){
      this.formErrorDeviceId[deviceNumber] = '';
    }else{
      this.formErrorDeviceId[deviceNumber] = 'Device id is required';
      this.error = true;
    }

    if(this.error){
      Swal('Error', 'Please provide complete details!', 'error');
    }else{

      this.updateDeviceLoader = true;
      this.route  = 'update-device-detail';
      const token = localStorage.getItem('userToken');
      this.deviceDetails[deviceNumber]['real_dataset'] = this.realDeviceDetails;
      this.deviceDetails[deviceNumber]['user_id'] = this.userName;
      this.deviceDetails[deviceNumber]['row_number'] = deviceNumber;
      let data = this.deviceDetails[deviceNumber];

      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
        }

        this.updateDeviceLoader = false;
        if(response.status == 200){
          this.getDeviceDetail();
          Swal('Success', 'Device details updated successfully', 'success');
        }else{
          Swal('Oops...', 'Something went wrong!', 'error');
        }
      });

    }

  }

}
